import { RefObject, useEffect } from 'react';

export function useIntersectionObserver({ targetRef, options, callback }: UseIntersectionObserver) {
  useEffect(() => {
    const target = targetRef.current;
    if (!target) return;

    const observer = new IntersectionObserver(callback, options);
    observer.observe(target);

    return () => {
      if (observer) {
        observer.unobserve(target);
      }
    };
  }, [targetRef, options, callback]);
}

interface UseIntersectionObserver {
  targetRef: RefObject<Element | null>;
  options: IntersectionObserverInit;
  callback: IntersectionObserverCallback;
}
